import { render, staticRenderFns } from "./TypeInformation.vue?vue&type=template&id=127f1258"
import script from "./TypeInformation.vue?vue&type=script&lang=js"
export * from "./TypeInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports